import * as A from '../actions/captchaActions';
import { ssCommonUtils } from '@bit/ui-common.ui-components/ss-utils';

const 
{ Request } = ssCommonUtils,
init = {
    request: new Request(),
    validation: new Request(),
    data: null,
    field: '',
};

export default (state=init, action) => { switch(action.type) {
    case A.CAPTCHA_PENDING:
        return {...state, request: {...state.request, status: 'pending' }};

    case A.CAPTCHA_SUCCESS:
        return {...state,
            request: {...state.request, status: 'success', validated:false },
            data: action.payload
        };

    case A.CAPTCHA_FAILURE:
        return {...state,
            request: {...state.request, status: 'failure' },
            data: action.payload
        };

    case A.CAPTCHA_RESET:
        return {...state, request: new Request(), data: null };

    case A.CAPTCHA_VALIDATION_PENDING:
        return {...state, validation: {...state.validation, status: 'pending'}};

    case A.CAPTCHA_VALIDATION_SUCCESS:
        return {...state, validation: {...state.validation, status: 'success' }};

    case A.CAPTCHA_VALIDATION_FAILURE:
        return {...state, validation: {...state.validation, status: 'failure' }};

    case A.CAPTCHA_VALIDATION_RESET:
        return {...state, validation: new Request(), field: '', status: '' };

    case A.CAPTCHA_INPUT_FIELD_UPDATE:
        return {...state, field: action.payload };
    
    case A.CAPTCHA_FIELD_RESET:
        return {...state, field: '' };

    case A.CAPTCHA_SET_VALIDATED:
        return {...state, validated:action.value};

        

    default: return {...state};
}}
